import { useState } from "react";
import "./Contact.css";
import {
  FiTool,
  FiHome,
  FiClipboard,
  FiHash,
  FiClock,
  FiUser,
  FiMapPin,
  FiMail,
  FiPhone,
  FiMessageCircle,
} from "react-icons/fi";

const initialState = {
  typeTravaux: "",
  typeBatiment: "",
  budget: "",
  pieces: "0",
  delai: "",
  nom: "",
  codePostal: "",
  email: "",
  telephone: "",
  message: ""
};

export const Contact = () => {
  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "typeTravaux",
      "nom",
      "email",
      "telephone",
    ];

    const newErrors = {};
    requiredFields.forEach((field) => {
      if (!String(formData[field] || "").trim()) {
        newErrors[field] = "Ce champ est obligatoire.";
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});

    // Extract first name and last name from full name
    const fullName = formData.nom.trim();
    const nameParts = fullName.split(' ');
    const prenom = nameParts[0] || '';
    const nom = nameParts.slice(1).join(' ') || nameParts[0] || '';

    // Prepare data for backend
    const devisData = {
      nom: nom,
      prenom: prenom,
      email: formData.email.trim(),
      telephone: formData.telephone.trim(),
      type_travaux: formData.typeTravaux,
      message: [
        formData.typeBatiment && `Type de bâtiment: ${formData.typeBatiment}`,
        formData.budget && `Budget: ${formData.budget}`,
        formData.pieces && `Nombre de pièces: ${formData.pieces}`,
        formData.delai && `Délai souhaité: ${formData.delai}`,
        formData.codePostal && `Code postal: ${formData.codePostal}`,
        formData.message && formData.message.trim()
      ].filter(Boolean).join('\n')
    };

    try {
      const API_URL = process.env.REACT_APP_API_URL || 'https://back.lexpertrenovation.fr';
      const response = await fetch(`${API_URL}/api/devis`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(devisData)
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setFormData(initialState);
        setShowSuccessModal(true);
        setTimeout(() => {
          setShowSuccessModal(false);
        }, 5000);
      } else {
        alert(data.error || "Une erreur est survenue. Veuillez réessayer plus tard.");
      }
    } catch (error) {
      alert("Une erreur est survenue. Veuillez réessayer plus tard.");
      console.error('Error:', error);
    }
  };

  return (
    <div id="Devis" className="contact-section" style={{ background: "linear-gradient(to right, #282828 0%, #414141 100%)" }}>
      <div className="text-center section-title">
        <h2 style={{ color: "white", paddingTop: "40px" }}>Demande de devis</h2>
      </div>

      <div className="form-container container devis-card">
        <h2>Obtenez votre devis personnalisé</h2>
        <p>
          Remplissez ce formulaire pour recevoir une estimation gratuite adaptée
          à votre projet.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiTool />
              </span>
              <span className="form-label-text">Type de travaux</span>
            </div>
            <select
              name="typeTravaux"
              value={formData.typeTravaux}
              onChange={handleChange}
              className={errors.typeTravaux ? "input-error" : ""}
            >
              <option value="">Sélectionner un type</option>
              <option value="RÉNOVATION COMPLÈTE">RÉNOVATION COMPLÈTE</option>
              <option value="EXTENSION-SURELEVATION">EXTENSION-SURELEVATION</option>
              <option value="SALLE DE BAIN CLÉ EN MAIN">SALLE DE BAIN CLÉ EN MAIN</option>
              <option value="RÉNOVATION INTÉRIEURE">RÉNOVATION INTÉRIEURE</option>
              <option value="RÉNOVATION EXTÉRIEURE">RÉNOVATION EXTÉRIEURE</option>
              <option value="GRANGE">GRANGE</option>
              <option value="NEUF">NEUF</option>
              <option value="AUTRE PROJET">AUTRE PROJET</option>

            </select>
            {errors.typeTravaux && (
              <span className="field-error">{errors.typeTravaux}</span>
            )}
          </div>

          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiHome />
              </span>
              <span className="form-label-text">Type de bâtiment</span>
            </div>
            <select
              name="typeBatiment"
              value={formData.typeBatiment}
              onChange={handleChange}
              className={errors.typeBatiment ? "input-error" : ""}
            >
              <option value="">Type de bâtiment </option>
              <option value="Appartement">Appartement</option>
              <option value="Maison Individuelle">Maison Individuelle</option>
              <option value="Bureau">Bureau</option>
              <option value="Commerce">Commerce</option>
              <option value="Immeuble">Immeuble</option>
              <option value="Local industriel">Local industriel</option>
              <option value="Usine">Usine</option>
              <option value="Hôtel">Hôtel</option>
              <option value="Autre">Autre</option>
            </select>
            {errors.typeBatiment && (
              <span className="field-error">{errors.typeBatiment}</span>
            )}
          </div>

          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiClipboard />
              </span>
              <span className="form-label-text">Budget estimé</span>
            </div>
            <select
              name="budget"
              value={formData.budget}
              onChange={handleChange}
              className={errors.budget ? "input-error" : ""}
            >
              <option value="">Quel est votre budget ?</option>
              <option value="Moins de 20 000 €">Moins de 20 000 €</option>
              <option value="De 20 000 à 50 000 €">De 20 000 à 50 000 €</option>
              <option value="De 50 000 à 100 000 €">De 50 000 à 100 000 €</option>
              <option value="Plus de 100 000 €">Plus de 100 000 €</option>
            </select>
            {errors.budget && (
              <span className="field-error">{errors.budget}</span>
            )}
          </div>

          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiHash />
              </span>
              <span className="form-label-text">
                Nombre de pièces concernées
              </span>
            </div>
            <input
              name="pieces"
              type="number"
              value={formData.pieces}
              onChange={handleChange}
              className={errors.pieces ? "input-error" : ""}
            />
            {errors.pieces && (
              <span className="field-error">{errors.pieces}</span>
            )}
          </div>

          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiClock />
              </span>
              <span className="form-label-text">Délai souhaité</span>
            </div>
            <select
              name="delai"
              value={formData.delai}
              onChange={handleChange}
              className={errors.delai ? "input-error" : ""}
            >
              <option value="">Choisir un délai</option>
              <option value="Le plus tôt possible">Le plus tôt possible</option>
              <option value="Dans 1 à 3 mois">Dans 1 à 3 mois</option>
              <option value="Dans 3 à 6 mois">Dans 3 à 6 mois</option>
            </select>
            {errors.delai && (
              <span className="field-error">{errors.delai}</span>
            )}
          </div>

          <div className="form-row">
            <div className="form-group">
              <div className="form-group-label">
                <span className="form-label-icon">
                  <FiUser />
                </span>
                <span className="form-label-text">Nom complet</span>
              </div>
              <input
                name="nom"
                type="text"
                value={formData.nom}
                onChange={handleChange}
                className={errors.nom ? "input-error" : ""}
              />
              {errors.nom && (
                <span className="field-error">{errors.nom}</span>
              )}
            </div>
            <div className="form-group">
              <div className="form-group-label">
                <span className="form-label-icon">
                  <FiMapPin />
                </span>
                <span className="form-label-text">Code postal</span>
              </div>
              <input
                name="codePostal"
                type="text"
                value={formData.codePostal}
                onChange={handleChange}
                className={errors.codePostal ? "input-error" : ""}
              />
              {errors.codePostal && (
                <span className="field-error">{errors.codePostal}</span>
              )}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <div className="form-group-label">
                <span className="form-label-icon">
                  <FiMail />
                </span>
                <span className="form-label-text">Email</span>
              </div>
              <input
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && (
                <span className="field-error">{errors.email}</span>
              )}
            </div>
            <div className="form-group">
              <div className="form-group-label">
                <span className="form-label-icon">
                  <FiPhone />
                </span>
                <span className="form-label-text">Téléphone</span>
              </div>
              <input
                name="telephone"
                type="tel"
                value={formData.telephone}
                onChange={handleChange}
                className={errors.telephone ? "input-error" : ""}
              />
              {errors.telephone && (
                <span className="field-error">{errors.telephone}</span>
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="form-group-label">
              <span className="form-label-icon">
                <FiMessageCircle />
              </span>
              <span className="form-label-text">
                Message complémentaire (facultatif)
              </span>
            </div>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
          </div>

          <button type="submit">Envoyer ma demande</button>
        </form>
      </div>

      {showSuccessModal && (
        <div className="success-modal-overlay">
          <div className="success-modal">
            <div className="success-modal-icon">✓</div>
            <h3>Demande envoyée avec succès !</h3>
            <p>Votre demande de devis a bien été reçue. Nous vous contacterons dans les plus brefs délais.</p>
          </div>
        </div>
      )}

      
      <br />
    </div>
  );
};
